import { deleteUser } from 'firebase/auth';
import { AuthState } from '../../interface/authState.interface';
import { INITIAL_STATE } from '../../utils/initialize.utils';

export const deleteAccount = async (set: any, get: any) => {
    // Start loading
    set((state: AuthState) => ({ ...state, loading: true, errorCode: undefined }));

    // Get attributes
    const { firebaseAuth } = get();

    const user = firebaseAuth.currentUser;

    if (user) {
        deleteUser(user)
            .then(() => {
                // User deleted.
                set({
                    ...INITIAL_STATE,
                    firebaseAuth,
                    initialLoading: false,
                });
            })
            .catch(() => {
                set((state: AuthState) => ({
                    ...state,
                    loading: false,
                    reauthenticating: true,
                }));
            });
    } else {
        set((state: AuthState) => ({
            ...state,
            loading: false,
            reauthenticating: true,
        }));
    }
};
